import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-double-image-bottom',
  templateUrl: './double-image-bottom.component.html',
  styleUrls: ['./double-image-bottom.component.scss'],
  // animations: [
  //   trigger('viewportAnimation', [
  //     state('initial', style({
  //       opacity: 0.0
  //     })),
  //     state('final', style({
  //       opacity: 1.0
  //     })),
  //     transition('initial=>final', animate('2000ms')),
  //     transition('final=>initial', animate('1000ms'))
  //   ]),
  // ]
})
export class DoubleImageBottomComponent implements OnInit {

  @Input() header: string;
  @Input() subHeader: string;
  @Input() text: string;
  @Input() imgLeft: string = "../../../assets/imgs/Placeholder.png";
  @Input() imgRight: string = "../../../assets/imgs/Placeholder.png";
  @Input() imgMiddle: string = "../../../assets/imgs/Placeholder.png";
  @Input() imgHoverTextRight: string;
  @Input() imgHoverTextMiddle: string;
  @Input() imgHoverTextLeft: string;
  @Input() buttonVisible: boolean;
  @Input() buttonLink: boolean;
  @Input() buttonText: string;

  leftClicked = false;


  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  currentState = 'initial';

  inViewPort(event)
  {
    if(event.visible == true)
    {
      this.currentState = 'final';
    }
    else{
      this.currentState = 'initial';
    }
  }

  leftImgClicked(content)
  {
    this.leftClicked = true;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  
  rightImgClicked(content)
  {
    this.leftClicked = false;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  middleImgClicked(content)
  {
    this.leftClicked = false;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

}
